export default __webpack_public_path__ + "static/media/down_red_solid.cb235642.svg";